"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES = void 0;

var _react = _interopRequireDefault(require("react"));

var _localization = require("@lt/localization");

var _iconsReact = require("../../../icons-react");

var TYPES = {
  instantConfirm: {
    order: 2,
    tooltipText: _localization.i18n.t('hotelcard.tag.instant.tooltip'),
    text: _localization.i18n.t('hotelcard.tag.instant.text'),
    tooltipColor: '#1E63E8'
  },
  notToConfirmAtOnce: {
    order: 2,
    tooltipText: _localization.i18n.t('hotelcard.tag.notToConfirmAtOnce.tooltip'),
    text: _localization.i18n.t('hotelcard.tag.notToConfirmAtOnce.text'),
    tooltipColor: '#B65800'
  },
  freeCancellation: {
    order: 3,
    text: _localization.i18n.t('hotelcard.tag.free_cancellation')
  },
  earlyBooking: {
    icon: /*#__PURE__*/_react["default"].createElement(_iconsReact.Clock, null),
    order: 4,
    tooltipText: _localization.i18n.t('hotelcard.tag.early.tooltip'),
    text: _localization.i18n.t('hotelcard.tag.early.text'),
    tooltipColor: '#4b137b'
  },
  crown: {
    order: 6,
    icon: /*#__PURE__*/_react["default"].createElement(_iconsReact.Crown, null)
  },
  rareConfirmation: {
    order: 6
  },
  advantages: {
    order: 6
  },
  fewChance: {
    order: 1
  },
  trustYou: {
    order: 5,
    icon: /*#__PURE__*/_react["default"].createElement(_iconsReact.Done, null)
  },
  filterPenalized: {
    order: 1
  },
  nothingRefund: {
    order: 3
  },
  partialRefund: {
    order: 3
  }
};
exports.TYPES = TYPES;